import React from "react";
import styled from 'styled-components/macro';
import PropTypes from 'prop-types';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

const StyledIcon = styled(FontAwesomeIcon).attrs(props => ({
    icon: [props.iconstyle, props.iconelement],
    listItem: props.listItem,
    color: props.color,
    className: props.className,
    size: props.size,
    title: props.title,
}))`
`;

export default class EnvimationIcon extends React.Component {
    render() {
        const iconStyle = this.props.iconStyle ? 'fa' + this.props.iconStyle.charAt(0) : 'fa';
        return <StyledIcon className={this.props.className}
                           iconelement={this.props.iconElement}
                           iconstyle={iconStyle}
                           color={this.props.color}
                           size={this.props.size}
                           title={this.props.title}
        />
    }
}

EnvimationIcon.defaultProps = {
    iconStyle: 'regular',
    listItem: false,
    size: 'xs',
    title: ''
};

EnvimationIcon.propTypes = {
    iconElement: PropTypes.string.isRequired,
    color: PropTypes.string,
    className: PropTypes.string,
    size: PropTypes.string,
    listItem: PropTypes.bool,
    iconStyle: PropTypes.oneOf(['regular', 'brand', 'solid', 'light']),
    title: PropTypes.string
};

export {StyledIcon};
